import { ReactNode } from "react";
import { useAuth } from "./context/auth";
import { Navigate, useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { currentUser } = useAuth();
  const location = useLocation();

  if (!currentUser) {
    /**
     * Carry the destination, and `replace` so the back button does not land
     * on the guarded page and bounce straight back here.
     *
     * This previously threw the destination away entirely — `<Navigate to="/auth" />`
     * with nothing attached — so somebody following a link to their own
     * certificate signed in and arrived at the course catalogue instead, with
     * nothing to tell them why. `/auth` now reads both this and `?returnTo=`.
     */
    const from = `${location.pathname}${location.search}`;
    return <Navigate to={`/auth?returnTo=${encodeURIComponent(from)}`} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
